import { useLocation } from "react-router-dom";

/* eslint-disable jsx-a11y/heading-has-content */
const NFTSkeltonLoader = () => {
  const location = useLocation()
  return (
    <div className="relative group border border-gray-300 bg-light-black rounded-[14px] overflow-hidden animate-pulse flex flex-col justify-between">
      <div className={`relative w-full ${location.pathname==='/profile' ? 'h-[176px]' :'h-[228px]'} animate-pulse bg-gray-400`}>
        <div className="absolute top-0 left-0 w-full flex justify-between px-4 py-2.5">
          <div className="text-md font-normal font-inter border rounded-full px-3 flex items-center bg-gray-300 w-16 h-6"></div>
        </div>
        <div className="absolute top-0 left-0 w-full flex justify-between px-4 py-2.5">
          <div className="w-full flex justify-end">
            <div className="w-6 h-6 bg-gray-200 animate-pulse rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="bg-light-black px-3 py-1.5 flex flex-col gap-2 justify-between ">
        <div>
          <div className="flex justify-between">
            <p className="w-16 h-4 bg-gray-300 rounded"></p>
            <div className="flex gap-2 items-center">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <p className="w-10 h-4 bg-gray-300 rounded"></p>
            </div>
          </div>
          <h6 className="w-2/3 h-5 bg-gray-300 rounded mt-2"></h6>
        </div>

        <div className="w-full flex flex-col sm:flex-row justify-between gap-2 py-1">
          <div className="h-10 w-full sm:w-[80%] bg-gray-200 animate-pulse rounded"></div>
          <div className="h-10 w-full sm:w-[20%] bg-gray-200 animate-pulse rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default NFTSkeltonLoader;
